module.exports = __webpack_public_path__ + "static/img/hjbanner.5b53812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hjbanner.png
// module id = xUGJ
// module chunks = 1